/**
 * @generated SignedSource<<0419030ca900c4f60f037ac70c30ae9c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AttachmentTypeInput = {
  document_id?: string | null | undefined;
  file?: AttachmentFileTypeInput | null | undefined;
  model_id: string;
  model_type: string;
  new_order?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type AttachmentFileTypeInput = {
  base64?: string | null | undefined;
  mime_type?: string | null | undefined;
  name?: string | null | undefined;
};
export type UpdateBulkAttachmentOrderMutation$variables = {
  input: AttachmentTypeInput;
};
export type UpdateBulkAttachmentOrderMutation$data = {
  readonly updateBulkAttachmentOrder: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"AttachmentFragment">;
  } | null | undefined> | null | undefined;
};
export type UpdateBulkAttachmentOrderMutation = {
  response: UpdateBulkAttachmentOrderMutation$data;
  variables: UpdateBulkAttachmentOrderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateBulkAttachmentOrderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Attachment",
        "kind": "LinkedField",
        "name": "updateBulkAttachmentOrder",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AttachmentFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateBulkAttachmentOrderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Attachment",
        "kind": "LinkedField",
        "name": "updateBulkAttachmentOrder",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "extension",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "order",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "created_by",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d0d5b019315d6601f8cc30f4fac52dbd",
    "id": null,
    "metadata": {},
    "name": "UpdateBulkAttachmentOrderMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateBulkAttachmentOrderMutation(\n  $input: AttachmentTypeInput!\n) {\n  updateBulkAttachmentOrder(input: $input) {\n    id\n    ...AttachmentFragment\n  }\n}\n\nfragment AttachmentFragment on Attachment {\n  id\n  name\n  extension\n  url\n  order\n  created_by\n}\n"
  }
};
})();

(node as any).hash = "c2d98d730b0330b2b7f653dfe96528cf";

export default node;
